module.exports = __webpack_public_path__ + "img/goods4.5f4d39a2.jpg";